import styled from "styled-components";
import { theme, typography } from "../styles";

export const StripSection = styled.section`
  padding: 64px 16px;
  border-top: 1px solid hsl(var(--hp-border) / 0.4);
  border-bottom: 1px solid hsl(var(--hp-border) / 0.4);
  background: ${theme.secondarySofter};
`;

export const StripInner = styled.div`
  width: 100%;
  max-width: 1152px;
  margin: 0 auto;
`;

export const StripTitle = styled.h2`
  margin: 0 0 40px;
  color: ${theme.foreground};
  font-size: clamp(1.5rem, 3vw, 1.875rem);
  font-weight: ${typography.weights.extrabold};
  line-height: 1.2;
  text-align: center;

  span {
    background-image: ${theme.gradientGold};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const AvatarRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px 20px;
  max-width: 640px;
  margin: 0 auto;

  @media (min-width: 640px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    max-width: 720px;
    gap: 32px 24px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    max-width: 960px;
  }

  @media (min-width: 1280px) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
    max-width: 1152px;
    gap: 24px;
  }
`;

export const AvatarItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  /* Lovable mobile: odd last analyst centered across the 2-col row */
  &:last-child {
    grid-column: 1 / -1;
  }

  @media (min-width: 640px) {
    &:last-child {
      grid-column: auto;
    }
  }
`;

export const AvatarWrap = styled.div`
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 50%;
  background: ${theme.muted};
  box-shadow: 0 0 0 2px hsl(32 95% 55% / 0.4);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  ${AvatarItem}:hover & {
    transform: scale(1.05);
    box-shadow: 0 0 0 2px ${theme.primary};
  }

  @media (min-width: 768px) {
    width: 96px;
    height: 96px;
  }
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const AvatarName = styled.p`
  margin: 12px 0 0;
  color: ${theme.foreground};
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const AvatarRole = styled.p`
  margin: 4px 0 0;
  color: hsl(var(--hp-primary) / 0.9);
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 0.75rem;
  }
`;
